import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { ActivityBannerType } from '../../../common/__generated__/api';
import { useStores } from '../../../utils/hooks';
import { MessageBanner, getBannerByType } from '.';
export var SearchMessageBanner = function () {
  var activitySearchStore = useStores().activitySearchStore;
  var banners = getBannerByType(activitySearchStore, ActivityBannerType.ALERT);
  if (!banners || banners.length <= 0) {
    return null;
  }
  var renderSearchMessageBanner = banners.map(function (banner, index) {
    return React.createElement(UitkSpacing, {
      margin: {
        inline: 'three',
        blockend: 'two',
        blockstart: 'one'
      },
      key: "banner-".concat(index)
    }, React.createElement(MessageBanner, {
      headerText: banner.title,
      bodyText: banner.subtitle,
      icon: banner.icon
    }));
  });
  return React.createElement(React.Fragment, null, renderSearchMessageBanner);
};